// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3olPv","footer":"ReportModalFilter_footer__HTV2_"};